import { Tag } from "../../common/tag"

export type ISODate = Tag<string, "iso-date">
